import React, {Component} from "react";
import {connect} from "react-redux";
import {setSettingsToRetrieve} from "../../../actions/settingsToRetrieveActions";
import {showToastForBackend, showToastForFrontend} from "../../../actions/toastActions";
import {clickedNodeAction} from "../../../actions/clickedNodeActions";

class RenameTotalResult extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isSelected: false,
            propertyName: {
                totalResultName: ''
            }
        };
        this.toggleInput = this.toggleInput.bind(this);
        this.inputHandle = this.inputHandle.bind(this);
        this.updateOptions = this.updateOptions.bind(this);
    }

    componentDidMount() {
        const settings = this.props.settingsToRetrieve;
        let isSelected = false;
        if (settings && settings.totalResultName)
            isSelected = true;
        this.setState({
                propertyName: {
                    totalResultName: settings ? settings.totalResultName : ''
                },
                isSelected
            }
        );
    }

    toggleInput() {
        this.setState(
            {isSelected: !this.state.isSelected}
        )
    }

    updateOptions() {
        const propertyName = this.state.propertyName;
        this.props.setSettingsToRetrieve(propertyName);
    }

    inputHandle(e) {
        this.setState({
            propertyName: {
                totalResultName: e.target.value
            }
        }, () => {
            this.updateOptions()
        });
    }

    render() {
        const {totalResultName} = this.state.propertyName;
        return (
            <div className="filter-group">
                <div className="filter-group-header">
                    <label className="checkbox-wrapper">
                        <input type="checkbox" className="checkbox" checked={this.state.isSelected}
                               onChange={this.toggleInput}/>
                        Rename total result
                    </label>
                </div>
                {this.state.isSelected &&
                    <div className="filter-group-content">
                        <div className="limit-form-area">
                            <div className="limit-form">
                                <label className="item">
                                    <input name="totalResultName"
                                           onChange={(event) => this.inputHandle(event)}
                                           className="panel-input" placeholder="Total result property name"
                                           type="text"
                                           value={totalResultName}/>
                                </label>
                            </div>
                        </div>
                    </div>
                }
            </div>
        )
    }
}

function

mapStateToProps(state) {
    return {
        settingsToRetrieve: state.settingsToRetrieve,
        clickedNodeInfo: state.clickedNodeInfo
    }
}

export default connect(mapStateToProps, {
    clickedNodeAction,
    setSettingsToRetrieve,
    showToastForFrontend,
    showToastForBackend
})(RenameTotalResult);